var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemperatureEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 320C133.49 320 112 341.49 112 368S133.49 416 160 416S208 394.51 208 368S186.51 320 160 320ZM272 278.5V112C272 50.125 221.875 0 160 0S48 50.125 48 112V278.5C28.25 303.125 16 334 16 368C16 447.5 80.5 512 160 512S304 447.5 304 368C304 334 291.75 303.125 272 278.5ZM160 464C107.125 464 64 420.875 64 368C64 341 75.75 320.75 85.5 308.5L96 295.375V112C96 76.75 124.75 48 160 48S224 76.75 224 112V295.25L234.5 308.375C244.25 320.75 256 341 256 368C256 420.875 212.875 464 160 464Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureEmpty);
export default __webpack_public_path__ + "static/media/temperature-empty.82ac8c70eddac00a5ab97be7060672b0.svg";
export { ForwardRef as ReactComponent };